import React from 'react';
import { Row } from 'react-bootstrap';
import { FormCol, FormFilterCard, FieldInput, FieldSelectIsActive } from 'motion-components';
import { useTranslation } from 'react-i18next';

export function buildWhereFromFilterValues(values): string {
  let where = {};
  if (values) {
    if (values.searchText) {
      where = {
        ...where,
        name: { $like: '%' + values.searchText + '%' },
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
  }
  return JSON.stringify(where);
}

export const Filters = ({ onChange, initialValues, disable = false }) => {
  const { t } = useTranslation();

  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? '',
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση')}
          type="search"
          disable={disable}
        />
        <FieldSelectIsActive name="isActive" label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};
